import platform from '@propertypal/shared/src/utils/platform';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';
import WaysToPayContent from '../components/ways-to-pay/WaysToPayContent';

const WaysToPayPage = () => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `Ways to Pay - ${platform.title}`,
          description: 'Ways To Pay - There are four ways to pay us: Cheque, Credit / Debit Card, Direct Debit',
          url: `/ways-to-pay`,
        })}
      </Head>
      <WaysToPayContent />
    </>
  );
};

export default WaysToPayPage;
